// Social & Custom Links of a role application: { name, url } pairs chosen
// freely by the applicant. Same rules as server_elakay
// elakay_helpers/applicationLinks.js; only technical limits apply.
export const MAX_APPLICATION_LINKS = 50;
export const MAX_LINK_NAME_LENGTH = 100;
export const MAX_LINK_URL_LENGTH = 2000;
// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;

export const emptyApplicationLink = () => ({ name: "", url: "" });

// The URL itself when it is an http(s) address with a host; otherwise null
// (javascript:, data:, credentials, relative paths, spaces...).
export const safeHttpUrl = (value) => {
  const text = String(value ?? "").trim();
  if (!text || text.length > MAX_LINK_URL_LENGTH || CONTROL_CHARACTERS.test(text) || /\s/.test(text)) return null;
  let parsed;
  try { parsed = new URL(text); } catch (_) { return null; }
  if (!["http:", "https:"].includes(parsed.protocol) || !parsed.hostname || parsed.username || parsed.password) return null;
  return text;
};

const isEmptyLink = (link) => !String(link?.name ?? "").trim() && !String(link?.url ?? "").trim();

// { name?: code, url?: code } for one row; {} when the row is valid or empty.
export const applicationLinkErrors = (link) => {
  if (isEmptyLink(link)) return {};
  const name = String(link?.name ?? "").trim();
  const url = String(link?.url ?? "").trim();
  const errors = {};
  if (!name) errors.name = "linkNameRequired";
  else if (name.length > MAX_LINK_NAME_LENGTH || CONTROL_CHARACTERS.test(name)) errors.name = "linkNameTooLong";
  if (!url) errors.url = "linkUrlRequired";
  else if (!safeHttpUrl(url)) errors.url = "invalidUrl";
  return errors;
};

export const validateApplicationLinks = (links = []) => {
  const rows = (links || []).map(applicationLinkErrors);
  const filled = (links || []).filter((link) => !isEmptyLink(link)).length;
  const tooMany = filled > MAX_APPLICATION_LINKS;
  return { rows, tooMany, valid: !tooMany && rows.every((row) => !Object.keys(row).length) };
};

// What is sent to the server: trimmed, fully empty rows dropped.
export const cleanApplicationLinks = (links = []) => (links || [])
  .filter((link) => !isEmptyLink(link))
  .map((link) => ({ name: String(link.name).trim(), url: String(link.url).trim() }));
